import { render, staticRenderFns } from "./ObservationModal.vue?vue&type=template&id=70562d2f&scoped=true&"
import script from "./ObservationModal.vue?vue&type=script&lang=js&"
export * from "./ObservationModal.vue?vue&type=script&lang=js&"
import style0 from "./ObservationModal.vue?vue&type=style&index=0&id=70562d2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70562d2f",
  null
  
)

export default component.exports